// English is the source of truth. `Dict` in ./types is derived from this file,
// so fr/de/ar fail to compile if a key is missing or misspelled.
const ar = {
  brand: { name: "SkillSynergy", first: "Skill", second: "Synergy" },

  nav: {
    courses: "الدورات",
    pricing: "الأسعار",
    about: "من نحن",
    contact: "تواصل",
    bookCall: "احجز مكالمة مجانية",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    language: "اللغة",
    skipToContent: "الانتقال إلى المحتوى",
  },

  cta: {
    exploreCourses: "استكشف الدورات",
    bookConsultation: "احجز استشارة مجانية",
    scheduleConsultation: "حدّد موعد استشارة مجانية",
    viewCourse: "عرض الدورة",
    viewAll: "عرض الكل",
    comparePlans: "قارن بين جميع الباقات",
    getInTouch: "تواصل معنا",
    enrollNow: "سجّل الآن",
    seePricing: "اطّلع على الأسعار",
    purchaseNow: "اشترِ الآن",
    contactUs: "اتصل بنا",
    done: "تم",
  },

  footer: {
    tagline: "دورات برمجة تطبيقية ومباشرة لكل المستويات.",
    coursesHeading: "الدورات",
    contactHeading: "تواصل معنا",
    contactBody: "لديك سؤال عن دورة؟ نردّ عادةً خلال يوم عمل واحد.",
    copyright: (year: number) =>
      `حقوق النشر © ${year} SkillSynergy. جميع الحقوق محفوظة.`,
    terms: "شروط الخدمة",
    privacy: "سياسة الخصوصية",
    imprint: "بيانات الناشر",
    cookieSettings: "إعدادات ملفات تعريف الارتباط",
    socialLabel: (network: string) => `SkillSynergy على ${network}`,
  },

  booking: {
    eyebrow: "استشارة مجانية",
    title: "لنرسم مسارك معًا في 30 دقيقة",
    body: "دون ضغط ودون تكلفة. سنقيّم مستواك ونوصي بالدورة والمسار المناسبين لك.",
    benefits: [
      "خطة تعلّم مصمّمة وفق أهدافك",
      "توجيه من مدرّب خبير",
      "إجابات حول الأسعار والجدول والصيغة",
    ],
    formTitle: "احجز مكالمتك المجانية",
    fullName: "الاسم الكامل",
    fullNamePlaceholder: "جين دو",
    email: "البريد الإلكتروني",
    emailPlaceholder: "jane@email.com",
    courseOfInterest: "الدورة التي تهمّك",
    notSureYet: "لم أقرر بعد",
    preferredTrack: "المسار المفضّل",
    bestTime: "أفضل وقت للاتصال",
    times: { morning: "صباحًا", afternoon: "بعد الظهر", evening: "مساءً" },
    submit: "اطلب مكالمتي المجانية",
    submitting: "جارٍ الإرسال…",
    disclaimer: "لن نشارك بياناتك أبدًا. نردّ خلال يوم عمل واحد.",
    successTitle: "تم استلام طلبك",
    successBody:
      "شكرًا لك، سنراسلك عبر البريد الإلكتروني خلال يوم عمل واحد لتأكيد استشارتك المجانية.",
    close: "إغلاق",
    error: "لم تكتمل العملية. يُرجى المحاولة مرة أخرى أو مراسلتنا مباشرة.",
  },

  form: {
    required: "هذا الحقل مطلوب.",
    invalidEmail: "أدخل عنوان بريد إلكتروني صالحًا.",
    consentLabel: "لقد قرأت ووافقت على",
    consentLink: "سياسة الخصوصية",
    consentSuffix: "وأوافق على استخدام بياناتي للردّ على استفساري.",
    consentRequired: "يُرجى قبول سياسة الخصوصية للمتابعة.",
    rateLimited:
      "لقد أرسلت هذا عدة مرات بالفعل. يرجى الانتظار قليلاً قبل المحاولة مرة أخرى.",
  },

  consent: {
    title: "نحترم خصوصيتك",
    body: "نستخدم ملفات تعريف الارتباط الضرورية لتشغيل هذا الموقع. وبإذنك، نودّ أيضًا جمع تقارير أخطاء مجهولة الهوية كي نصلح المشكلات بسرعة أكبر. يمكنك تغيير رأيك في أي وقت.",
    acceptAll: "قبول الكل",
    rejectAll: "رفض غير الضروري",
    save: "حفظ الاختيارات",
    customise: "تخصيص",
    privacyLink: "سياسة الخصوصية",
    imprintLink: "بيانات الناشر",
    categories: {
      necessary: {
        title: "ضرورية تمامًا",
        body: "لازمة لعمل الموقع: لغتك، واختياراتك لملفات تعريف الارتباط، والأمان الأساسي. هذه لا تغادر خوادمنا أبدًا.",
        always: "مفعّلة دائمًا",
      },
      analytics: {
        title: "الإبلاغ عن الأخطاء",
        body: "تحمّل Sentry الذي يبلّغ عن الأعطال والأخطاء كي نصلحها. يتلقّى عنوان IP الخاص بك وتفاصيل متصفحك.",
      },
    },
  },

  a11y: {
    previous: "السابق",
    next: "التالي",
    breadcrumb: "مسار التنقّل",
    home: "الرئيسية",
    newTab: "يُفتح في علامة تبويب جديدة",
  },
};

export default ar;
